import { Box } from '@mui/material';

import useResponsive from '@/components/hooks/useResponsive';
import useTestFlags from '@/components/hooks/useTestFlags';
import { handleUserNeedSelected } from '@/components/shared/HomePageTopNavigation/utils';
import ZipCodePanel from '@/components/shared/ZipCodePanel/ZipCodePanel';
import { VERTICALS_NAMES } from '@/constants';
import { Location } from '@/types';
import { AnalyticsEventName, CtaLocation, CtaText, ScreenName } from '@/types/enums';
import { AnalyticsHelper } from '@/utilities/AnalyticsHelper';

const HeroZipPanel = () => {
  const { vhpTriageProviderVertical } = useTestFlags();
  const routeProviderToTriagePage = vhpTriageProviderVertical?.value === 2;
  const { isDesktop } = useResponsive();

  const onZipCodeSelected = (locationEntered: Location | undefined, isProvider: boolean) => {
    // define a user needs for all users
    const userNeed = isProvider ? 'Find jobs' : 'Find care';

    let zipData = {};
    if (locationEntered) {
      const { city, state, verifiedApiZipcode: zip } = locationEntered;
      zipData = {
        zip,
        city,
        state,
      };
    }

    AnalyticsHelper.logEvent({
      name: AnalyticsEventName.CTA_INTERACTED_VHP,
      data: {
        screen_name: ScreenName.VISITOR_HOMEPAGE,
        cta_location: CtaLocation.VHP_HERO,
        enrollment_initiated: true,
        vertical: VERTICALS_NAMES.unknown,
        user_need: userNeed,
        cta_text: CtaText.SEARCH,
        ...zipData,
      },
    });

    handleUserNeedSelected(isProvider, isDesktop, routeProviderToTriagePage);
  };

  return (
    <Box
      sx={{
        marginTop: {
          xs: 5,
          sm: 4,
        },
        padding: {
          xs: 3,
        },
        width: {
          xs: '100%',
          sm: '368px',
          md: '400px',
        },
        backgroundColor: 'rgba(247, 245, 240, 0.16)',
        backdropFilter: 'blur(40px)',
        borderRadius: '24px',
      }}>
      <ZipCodePanel onZipCodeSelected={onZipCodeSelected} panelCtaText={CtaText.SEARCH} iconLeft />
    </Box>
  );
};

export default HeroZipPanel;
